'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.flat || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.flat/polyfill.js
// module id = 570
// module chunks = 0